/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsNativePitrConfig } from '../models/AwsNativePitrConfig';
import { BackupPolicyType } from '../models/BackupPolicyType';
import { Condition } from '../models/Condition';
import { CreatePolicyScheduleInput } from '../models/CreatePolicyScheduleInput';
import { Provider } from '../models/Provider';
import { ResourceType } from '../models/ResourceType';
import { ScheduleMode } from '../models/ScheduleMode';

export class CreatePolicyInput {
  /**
  * The name of the policy
  */
  'name': string;
  /**
  * Whether the policy is enabled
  */
  'enabled': boolean;
  'condition'?: Condition;
  'include': Array<string>;
  'exclude': Array<string>;
  'policyType'?: BackupPolicyType;
  'scheduleMode'?: ScheduleMode;
  'schedules': Array<CreatePolicyScheduleInput>;
  /**
  * Whether the security scan is enabled
  */
  'isSecurityScanEnabled'?: boolean;
  'sourceCloudProvider'?: Provider;
  'resourceTypes'?: Array<ResourceType>;
  'awsNativePitrConfig'?: AwsNativePitrConfig | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "condition",
      "baseName": "condition",
      "type": "Condition",
      "format": ""
    },
    {
      "name": "include",
      "baseName": "include",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "exclude",
      "baseName": "exclude",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "policyType",
      "baseName": "policyType",
      "type": "BackupPolicyType",
      "format": ""
    },
    {
      "name": "scheduleMode",
      "baseName": "scheduleMode",
      "type": "ScheduleMode",
      "format": ""
    },
    {
      "name": "schedules",
      "baseName": "schedules",
      "type": "Array<CreatePolicyScheduleInput>",
      "format": ""
    },
    {
      "name": "isSecurityScanEnabled",
      "baseName": "isSecurityScanEnabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "sourceCloudProvider",
      "baseName": "sourceCloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "resourceTypes",
      "baseName": "resourceTypes",
      "type": "Array<ResourceType>",
      "format": ""
    },
    {
      "name": "awsNativePitrConfig",
      "baseName": "awsNativePitrConfig",
      "type": "AwsNativePitrConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreatePolicyInput.attributeTypeMap;
  }

  public constructor() {
  }
}



